@file:Suppress("DEPRECATION")
package org.example.newportfolio.components.sections.contact

import androidx.compose.runtime.Composable
import org.example.newportfolio.components.sections.contact.components.ContactCard
import org.example.newportfolio.components.widgets.section.SectionContainer
import org.example.newportfolio.components.widgets.section.SectionContainerStyle
import org.example.newportfolio.models.Section
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.style.addVariant
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

val ContactSectionVariant by SectionContainerStyle.addVariant {
    base {
        Modifier
            .styleModifier {
                property("padding-top", "3rem")
                property("padding-bottom", "3rem")
                property("padding-left", "16px")
                property("padding-right", "16px")
            }
            .minHeight(500.px)
    }
    Breakpoint.MD {
        Modifier.height(85.vh).styleModifier {
            property("padding-top", "0")
            property("padding-bottom", "0")
            property("padding-left", "48px")
            property("padding-right", "48px")
        }
    }
    Breakpoint.LG {
        Modifier.styleModifier {
            property("padding-left", "94px")
            property("padding-right", "94px")
        }
    }
    Breakpoint.XL {
        Modifier.styleModifier {
            property("padding-left", "134px")
            property("padding-right", "134px")
        }
    }
}

@Composable
fun ContactSection() {
    SectionContainer(
        variant = ContactSectionVariant,
        section = Section.Contact,
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        // Whole card fades up as you scroll to it — the section's
        // "arrival" moment after the rest of the page has unfolded.
        //
        // contentAlignment = Center is critical: ContactCard sets its
        // own width to 60-65% at LG/XL via fillMaxWidth fractions, so
        // without it the card would sit at top-start of this full-width
        // wrapper Box (which is exactly what was happening on desktop).
        Box(
            modifier = Modifier.fillMaxWidth().classNames("scroll-reveal"),
            contentAlignment = Alignment.Center
        ) {
            ContactCard()
        }
    }
}